<template>
    <!-- S'il s'agit d'une liste avec une seule sélection possible -->
    <multiselect :id="field.Name"
                 :options="field.ListName ? listItems(field.ListName, field.TargetFilter, field.FilterValue, field.ExcludedItems) : field.ListItems"
                 :disabled="ConsultMode === objectDisplayingModeEnum.Read || field.Disabled || field.ReadOnly"
                 :required="field.Required"
                 :close-on-select="true"
                 :allow-empty="true"
                 :searchable="true"
                 :show-labels="false"
                 :multiple="false"
                 :max-height="150"
                 track-by="Id"
                 label="Label"
                 placeholder=""
                 class="mt-0 mb-0 ml-0 mr-3 pt-0 d-inline-block h-100"
                 :style="ConsultMode === objectDisplayingModeEnum.Read ? 'background: transparent !important; background-color: transparent !important' : 'background: white !important; background-color: white !important'"
                 v-model="selectedValue"
                 @input="updateValue(field)">

        <template #caret={toggle}>
						<span class="multiselect__select pr-0">
							<b-icon icon="chevron-down" font-scale="0.55" shift-h="0"
                                    style="stroke: black !important; stroke-width: 1.5px !important;"/>
						</span>
        </template>
    </multiselect>
</template>

<script lang="ts">
import {Vue, Component, Prop, Watch, PropSync} from "vue-property-decorator";
import {Getter} from "vuex-class";
import SelectListField from "@/types/fields/SelectListField";
import ListItem from "@/types/fields/ListItem";
import ObjectDisplayingModeEnum from "@/enums/ObjectDisplayingModeEnum";
import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
import Multiselect from 'vue-multiselect';

@Component({
    components: {
        Multiselect
    }
})
export default class SelectList extends Vue {
    /** Pour pouvoir utiliser les enums dans la section template */
    private fieldTypeEnum = FieldTypeEnum;
    private objectDisplayingModeEnum = ObjectDisplayingModeEnum;

    /** Indique si les champs du formulaire sont éditables ou en mode consultation */
    @Prop()
    public ConsultMode!: ObjectDisplayingModeEnum;

    /** Champ de type SelectListField à traiter */
    @PropSync('Field')
    public field!: SelectListField;

    /** Items de SelectList obtenu en async */
    @Getter('GetListItems')
    private listItems!: (listName: string, targetFilter: string, filterValue: number, excludedItems: number[]) => ListItem[];

    /** Valeur sélectionnée dans le composant MultiSelect */
    private selectedValue: ListItem = {} as ListItem;

    private find(list: ListItem[], attribute: string, value: any): any {
        let id = list.findIndex(x => x[attribute] == value);
        if (id > -1)
            return list[id];
        else
            return;
    }

    @Watch('field.FilterValue', {immediate: true})
    private async updateListItems() {
        if (this.field.FilterValue != 0)
            await this.$store.dispatch("LoadListItems", [{
                listName: this.field.ListName,
                targetFilter: this.field.TargetFilter,
                filterValue: this.field.FilterValue
            }]);
    }

    /** Mise à jour de la valeur d'un field */
    private updateValue(element: SelectListField) {
        console.debug("SelectListField.vue - updateValue - base - element.Value : %O, selectedValue", element.Value, this.selectedValue);

        element.Value = this.selectedValue ? this.selectedValue.Id : null;
        element.Extras = this.selectedValue ? this.selectedValue.Extras : {}; // peut pas être null car provoque des erreurs sur des éléments internes à cet objet

        this.$store.dispatch("ObjectStore/UpdateValue", {newElement: element});
    }

    async mounted() {
        if (this.field.ListName) {
            await this.$store.dispatch("LoadListItems", [{
                listName: this.field.ListName,
                targetFilter: this.field.TargetFilter,
                filterValue: this.field.FilterValue
            }]);
        }

        this.$watch('field.Value', (newVal, oldVal) => {
            if (this.field.ListName)
                this.selectedValue = this.find(this.listItems(this.field.ListName, this.field.TargetFilter, this.field.FilterValue, this.field.ExcludedItems), "Id", this.field.Value);
            else
                /** @todo : Gérer le cas de l'exclusion et du filtre en cas de besoin */
                this.selectedValue = this.find(this.field.ListItems, "Id", this.field.Value);
        }, {immediate: true});
    }
}
</script>

<style scoped>

</style>